(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["text-with-multi-buttons"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    function showError(input, message) {
      const errorElement = document.getElementById(input.id + '-error');
      if (errorElement) {
        errorElement.style.display = 'block';
        input.classList.add('error');
      }
    }

    function hideError(input) {
      const errorElement = document.getElementById(input.id + '-error');
      if (errorElement) {
        errorElement.style.display = 'none';
        input.classList.remove('error');
      }
    }

    function validateEmail(email) {
      email = email.replace(/\s/g, '');
      const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return re.test(email.toLowerCase());
    }

    function validatePhone(phone) {
      phone = phone.replace(/\s/g, '');
      const re = /^[+]?[0-9]{10,13}$/;
      return re.test(phone);
    }

    function preventSpaces(input) {
      input.value = input.value.replace(/\s/g, '');
    }

    function cleanInputValue(input) {
      if (input.type === 'email' || input.type === 'tel') {
        return input.value.replace(/\s/g, '');
      } else {
        return input.value.replace(/\s+/g, ' ').trim();
      }
    }

    function initializeTextareaPlaceholder(formElement) {
      if (!formElement) return;

      const textarea = formElement.querySelector('textarea');
      const placeholder = formElement.querySelector('.textarea-placeholder');

      if (textarea && placeholder) {
        if (textarea.value.trim() !== '') {
          placeholder.style.display = 'none';
        }

        textarea.addEventListener('input', function () {
          placeholder.style.display = this.value.trim() === '' ? 'block' : 'none';
        });

        textarea.addEventListener('focus', function () {
          placeholder.style.display = 'none';
        });

        textarea.addEventListener('blur', function () {
          if (this.value.trim() === '') {
            placeholder.style.display = 'block';
          }
        });
      }
    }

    function initializeCategoryQuantities() {
      function initializeFormCategories(formElement) {
        if (!formElement) return;

        const checkboxes = formElement.querySelectorAll('.contact-forms-categorys-wrapper input[type="checkbox"]');

        checkboxes.forEach((checkbox) => {
          checkbox.addEventListener('change', function () {
            const category = this.value;
            const categoryItem = this.closest('.category-item');
            const quantityDiv = categoryItem.querySelector('.selected-category-quantity');

            if (quantityDiv) {
              if (this.checked) {
                quantityDiv.classList.add('show');
              } else {
                quantityDiv.classList.remove('show');
                const quantityInput = quantityDiv.querySelector('input[type="number"]');
                if (quantityInput) {
                  quantityInput.value = 0;
                }
              }
            }
          });
        });

        initializeTextareaPlaceholder(formElement);
      }

      initializeFormCategories(document.getElementById('corporateGiftingForm'));

      const popupContent = document.getElementById('popupFormContent');
      if (popupContent) {
        const observer = new MutationObserver((mutations) => {
          mutations.forEach((mutation) => {
            if (mutation.addedNodes.length) {
              mutation.addedNodes.forEach((node) => {
                if (node.id === 'corporateGiftingForm' || node.id === 'franchiseOpportunityForm') {
                  initializeFormCategories(node);
                  initializeTextareaPlaceholder(node);
                }
              });
            }
          });
        });

        observer.observe(popupContent, { childList: true });
      }
    }

    function initializeFormPopup() {
      const popup = document.getElementById('formPopup');
      const popupContent = document.getElementById('popupFormContent');
      const buttons = document.querySelectorAll('[data-form-id]');
      let touchStartX = 0;
      let touchEndX = 0;
      const isMobile = window.innerWidth <= 767;

      function openPopup(button) {
        const formId = button.getAttribute('data-form-id');
        const targetForm = document.getElementById(formId);

        if (targetForm) {
          const formClone = targetForm.cloneNode(true);

          popupContent.innerHTML = '';
          popupContent.appendChild(formClone);

          popup.classList.add('active');
          document.body.style.overflow = 'hidden';

          if (formId === 'corporateGiftingForm') {
            initializeCorporateGiftingForm(formClone);
          } else if (formId === 'franchiseOpportunityForm') {
            initializeFranchiseOpportunityForm(formClone);
          }

          const deskHideCloseButtons = formClone.querySelectorAll('.desk-hide.form-popup__close');
          deskHideCloseButtons.forEach((closeBtn) => {
            closeBtn.addEventListener('click', function (e) {
              e.preventDefault();
              closePopup();
            });
          });
        }
      }

      buttons.forEach((button) => {
        button.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          openPopup(this);
        });
      });

      function closePopup() {
        if (isMobile) {
          const content = popup.querySelector('.form-popup__content');
          content.style.right = '-100%';
          setTimeout(() => {
            popup.classList.remove('active');
            document.body.style.overflow = '';
            popupContent.innerHTML = '';
            content.style.right = '';
          }, 300);
        } else {
          popup.classList.remove('active');
          document.body.style.overflow = '';
          setTimeout(() => {
            popupContent.innerHTML = '';
          }, 300);
        }
      }

      const closeButton = popup.querySelector('.form-popup__close');
      if (closeButton) {
        closeButton.addEventListener('click', function (e) {
          e.preventDefault();
          closePopup();
        });
      }

      if (isMobile) {
        popup.addEventListener(
          'touchstart',
          (e) => {
            touchStartX = e.touches[0].clientX;
          },
          { passive: true }
        );

        popup.addEventListener(
          'touchmove',
          (e) => {
            if (e.touches[0].clientX > touchStartX) {
              const content = popup.querySelector('.form-popup__content');
              const diff = e.touches[0].clientX - touchStartX;
              if (diff < window.innerWidth * 0.85) {
                content.style.right = `-${diff}px`;
              }
            }
          },
          { passive: true }
        );

        popup.addEventListener('touchend', (e) => {
          touchEndX = e.changedTouches[0].clientX;
          const content = popup.querySelector('.form-popup__content');

          if (touchEndX - touchStartX > window.innerWidth * 0.3) {
            closePopup();
          } else {
            content.style.right = '0';
          }
        });
      }

      popup.addEventListener('click', function (e) {
        if (e.target === popup) {
          closePopup();
        }
      });

      popupContent.addEventListener('click', function (e) {
        e.stopPropagation();
      });
    }

    function showThankYouPopup() {
      const thankYouPopup = document.getElementById('thankYouPopup');
      const formPopup = document.getElementById('formPopup');

      formPopup.classList.remove('active');
      document.body.style.overflow = '';

      thankYouPopup.classList.add('active');
      document.body.style.overflow = 'hidden';
    }

    function closeThankYouPopup() {
      const thankYouPopup = document.getElementById('thankYouPopup');
      thankYouPopup.classList.remove('active');
      document.body.style.overflow = '';
      window.location.href = '/';
    }

    function initializeThankYouPopup() {
      const thankYouPopup = document.getElementById('thankYouPopup');
      const closeButton = thankYouPopup.querySelector('.thank-you-popup__close');
      const continueButton = thankYouPopup.querySelector('.thank-you-popup__button');

      closeButton.addEventListener('click', closeThankYouPopup);
      continueButton.addEventListener('click', closeThankYouPopup);

      thankYouPopup.addEventListener('click', function (e) {
        if (e.target === thankYouPopup) {
          closeThankYouPopup();
        }
      });
    }

    function initializeCorporateGiftingForm(form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        let isValid = true;

        const companyName = form.querySelector('#company-name');
        const companyEmail = form.querySelector('#company-email-id');
        const contactNumber = form.querySelector('#contact-number');
        const textarea = form.querySelector('#contact-textarea');
        const categories = form.querySelectorAll('input[name="Categories"]:checked');
        const brands = form.querySelectorAll('input[name="Brands"]:checked');

        if (!companyName.value.trim()) {
          showError(companyName);
          isValid = false;
        } else {
          hideError(companyName);
        }

        if (!validateEmail(companyEmail.value)) {
          showError(companyEmail);
          isValid = false;
        } else {
          hideError(companyEmail);
        }

        if (!validatePhone(contactNumber.value)) {
          showError(contactNumber);
          isValid = false;
        } else {
          hideError(contactNumber);
        }

        const messageLength = textarea.value.trim().length;
        if (messageLength < 0 || messageLength > 120) {
          showError(textarea);
          document.getElementById('contact-textarea-error').style.display = 'block';
          isValid = false;
        } else {
          hideError(textarea);
        }

        if (categories.length === 0) {
          const errorElement = form.querySelector('#categories-error');
          if (errorElement) errorElement.style.display = 'block';
          isValid = false;
        }

        if (brands.length === 0) {
          const errorElement = form.querySelector('#brands-error');
          if (errorElement) errorElement.style.display = 'block';
          isValid = false;
        }

        if (isValid) {
          const inputs = form.querySelectorAll('input[type="text"], input[type="email"], input[type="tel"], textarea');
          inputs.forEach((input) => {
            input.value = cleanInputValue(input);
          });

          const formData = new FormData(form);
          const data = {};
          formData.forEach((value, key) => {
            if (data[key]) {
              if (!Array.isArray(data[key])) {
                data[key] = [data[key]];
              }
              data[key].push(value);
            } else {
              data[key] = value;
            }
          });

          if (form.id === 'corporateGiftingForm') {
            const selectedCategories = [];
            form.querySelectorAll('.category-item input[type="checkbox"]:checked').forEach((checkbox) => {
              const categoryItem = checkbox.closest('.category-item');
              const quantityInput = categoryItem.querySelector('input[type="number"]');
              const qty = quantityInput ? parseInt(quantityInput.value) || 0 : 0;
              if (qty > 0) {
                selectedCategories.push(`${checkbox.value} (${qty} pieces)`);
              }
            });
            data.Categories = selectedCategories.join(', ');
          }

          const submitButton = form.querySelector('button[type="submit"]');
          submitButton.classList.add('loading');
          submitButton.disabled = true;

          fetch(form.action, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json',
            },
            body: JSON.stringify(data),
          })
            .then((response) => {
              if (!response.ok) {
                throw new Error('Network response was not ok');
              }
              showThankYouPopup();
              form.reset();
              submitButton.classList.remove('loading');
              submitButton.disabled = false;
            })
            .catch((error) => {
              console.error('Error:', error);
              alert('There was an error submitting the form. Please try again.');
              submitButton.classList.remove('loading');
              submitButton.disabled = false;
            });
        }
      });
    }

    function initializeFranchiseOpportunityForm(form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        let isValid = true;

        const companyName = form.querySelector('#fo-company-name');
        const contactEmail = form.querySelector('#fo-contact-email');
        const backgroundOptions = form.querySelectorAll('input[name="Background"]:checked');

        if (!companyName.value.trim()) {
          showError(companyName);
          isValid = false;
        } else {
          hideError(companyName);
        }

        if (!validateEmail(contactEmail.value)) {
          showError(contactEmail);
          isValid = false;
        } else {
          hideError(contactEmail);
        }

        if (backgroundOptions.length === 0) {
          const errorElement = form.querySelector('#background-error');
          if (errorElement) errorElement.style.display = 'block';
          isValid = false;
        }

        if (isValid) {
          const inputs = form.querySelectorAll('input[type="text"], input[type="email"]');
          inputs.forEach((input) => {
            input.value = cleanInputValue(input);
          });

          const formData = new FormData(form);
          const data = {};
          formData.forEach((value, key) => {
            if (data[key]) {
              if (!Array.isArray(data[key])) {
                data[key] = [data[key]];
              }
              data[key].push(value);
            } else {
              data[key] = value;
            }
          });

          const backgroundYes = form.querySelector('#background-yes');
          const backgroundNo = form.querySelector('#background-no');
          data.Background = backgroundYes.checked ? 'Yes' : backgroundNo.checked ? 'No' : '';

          const submitButton = form.querySelector('button[type="submit"]');
          submitButton.classList.add('loading');
          submitButton.disabled = true;

          fetch(form.action, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json',
            },
            body: JSON.stringify(data),
          })
            .then((response) => {
              if (!response.ok) {
                throw new Error('Network response was not ok');
              }
              showThankYouPopup();
              form.reset();
              submitButton.classList.remove('loading');
              submitButton.disabled = false;
            })
            .catch((error) => {
              console.error('Error:', error);
              alert('There was an error submitting the form. Please try again.');
              submitButton.classList.remove('loading');
              submitButton.disabled = false;
            });
        }
      });
    }

    const mainCorporateForm = document.getElementById('corporateGiftingForm');
    const mainFranchiseForm = document.getElementById('franchiseOpportunityForm');

    if (mainCorporateForm) {
      initializeCorporateGiftingForm(mainCorporateForm);
    }
    if (mainFranchiseForm) {
      initializeFranchiseOpportunityForm(mainFranchiseForm);
    }

    initializeFormPopup();
    initializeThankYouPopup();
    initializeCategoryQuantities();

    const noSpaceInputs = document.querySelectorAll('input[type="email"], input[type="tel"]');
    noSpaceInputs.forEach((input) => {
      input.addEventListener('input', function () {
        preventSpaces(this);
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
